// Convex client configuration.
//
// Reads CONVEX_URL from Vite env (VITE_CONVEX_URL). Vercel should set this
// per-environment in its dashboard; local dev copies dashboard/.env.example
// to dashboard/.env.local.
//
// Defensive fallback: if the env is missing OR contains the known typo
// "avocot", we correct to the canonical deployment. This mirrors the
// Python-side fix in scripts/env_bootstrap.py for the same typo class.

const CANONICAL_CONVEX_URL = "https://quiet-avocet-702.convex.cloud";
const KNOWN_TYPO = "avocot";

function resolveConvexUrl(): string {
  const envUrl = import.meta.env.VITE_CONVEX_URL;
  if (!envUrl) {
    console.warn("VITE_CONVEX_URL not set; falling back to canonical deployment.");
    return CANONICAL_CONVEX_URL;
  }
  if (envUrl.includes(KNOWN_TYPO)) {
    console.warn(
      `VITE_CONVEX_URL contains known typo "${KNOWN_TYPO}"; correcting to canonical deployment.`
    );
    return CANONICAL_CONVEX_URL;
  }
  return envUrl;
}

export const CONVEX_URL = resolveConvexUrl();
